export const MAIN_API = process.env.REACT_APP_API_URL;

/* ---------------------------- ALL category API ---------------------------- */
export const GET_CATEGORY_API = "/api/app/category/getcategory";
/* ---------------------------- END category API ---------------------------- */
/* ---------------------------- ALL state API ---------------------------- */
export const GET_STATE_API = "/api/app/state/getstate";
/* ---------------------------- END state API ---------------------------- */

/* ---------------------------- ALL city API ---------------------------- */
export const GET_CITY_API = "/api/app/city/getcity";
export const GET_CITY_BY_STATE_ID_API = "/api/app/city/getcitybystateid";
/* ---------------------------- END city API ---------------------------- */
/* ---------------------------- ALL venue API ---------------------------- */
export const GET_VENUE_API = "/api/app/venue/getvenue";
export const GET_VENUE_BY_CITY_ID_API = "/api/app/venue/getvenuebycityid";
/* ---------------------------- END venue API ---------------------------- */
/* ---------------------------- ALL event API ---------------------------- */
export const GET_FEATURED_EVENT_API = "/api/app/event/featuredevent";
export const GET_COUNT_API = "/api/app/event/counts";
export const GET_SEARCH_EVENT_API = "/api/app/event/allEvent?page=";
export const GET_EVENT_BY_ID_API = "/api/app/event/event/";
export const GET_SESSION_BY_DAY_ID_API = "/api/app/event/getshedule";
export const GET_SEARCH_SUGGESTION_API = "/api/app/event/serceSuggetion";
export const GET_EVENT_SPONSOR_API = "/api/app/event/getsponsor";
/* ---------------------------- END event API ---------------------------- */
/* ---------------------------- ALL blog API ---------------------------- */
export const GET_LATEST_BLOG_API = "/api/app/blog/getlatestblog";
export const GET_BLOG_BY_ID_API = "/api/app/blog/getblogbyid";
export const GET_ALL_BLOG_API = "/api/app/blog/getallblog?page=";
/* ---------------------------- END blog API ---------------------------- */
/* ---------------------------- ALL sponser API ---------------------------- */
export const GET_SPONSOR_API = "/api/app/sponser/getsponser";
/* ---------------------------- END sponser API ---------------------------- */
/* ---------------------------- ALL auth API ---------------------------- */
export const REGISTER_API = "/api/app/user/register";
export const VERIFY_EMAIL_API = "/api/app/user/verifyemail";
export const LOGIN_API = "/api/app/user/login";
export const GOOGLE_USER_INFO_API = "https://www.googleapis.com/oauth2/v3/userinfo";
export const SOCIAL_LOGIN_API = "/api/app/user/socialLogin";
export const CHECK_EMAIL_API = "/api/app/user/checkemail";
export const VERIFY_OTP_API = "/api/app/user/verifyotp";
export const FORGOT_PASSWORD_API = "/api/app/user/forgotpassword";
export const GET_POPUP_IMAGE_API = "/api/app/user/getpopupimage";
/* ---------------------------- END auth API ---------------------------- */
/* ---------------------------- ALL appSettings API ---------------------------- */
export const GET_APP_SETTINGS_API = "/api/app/user/getappsetting";
/* ---------------------------- END appSettings API ---------------------------- */

/* ---------------------------- ALL contact API ---------------------------- */
export const SEND_MESSAGE_API = "/api/app/contectus/sendmessage";
/* ---------------------------- END contact API ---------------------------- */
/* ---------------------------- ALL cart API ---------------------------- */
export const GET_CART_API = "/api/app/cart/getcart";
export const ADD_CART_API = "/api/app/cart/addtocart";
export const REMOVE_CART_API = "/api/app/cart/removefromcart";
export const UPDATE_CART_API = "/api/app/cart/updatecart";
/* ---------------------------- END cart API ---------------------------- */
/* ---------------------------- ALL discount API ---------------------------- */
export const APPLY_DISCOUNT_API = "/api/app/cart/applycuponcode";
export const GET_DISCOUNT_API = "/api/app/cart/getcuponcode";
/* ---------------------------- END discount API ---------------------------- */
/* ---------------------------- ALL order API ---------------------------- */
export const CHECKOUT_API = "/api/app/order/createorder";
export const GUEST_CHECKOUT_API = "/api/app/order/guestcreateorder";
export const VERIFY_PAYMENT_API = "/api/app/order/successpayment";
export const GUEST_VERIFY_PAYMENT_API = "/api/app/order/guestsuccesspayment";
export const GET_ORDER_API = "/api/app/order/getorders";
export const POST_REVIEW_API = "/api/app/order/addrating";
export const GET_ORDER_BY_ID_API = "/api/app/order/getorderbyid";
export const DOWNLOAD_TICKET_PDF_API = "/api/app/order/downloadticketpdf";
/* ---------------------------- END order API ---------------------------- */
